import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import ListOfBasestationsBody from './ListOfBasestationsBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { admin, NOC } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import ListOfBasestationsProvider from './context/ListOfBasestationsContext';
import { VICE_PRESIDENT_FSE } from '../../../../../../utils/departments/helpers';

const ListOfBasestations = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <ListOfBasestationsProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="NOC Sheet - List of Basestations" position={firstName} />
          <div className="container">
            <div className="row mt-5">
              <div className="mt-4 col-lg-12 col-md-12 col-sm-12">
                <ListOfBasestationsBody />
              </div>
            </div>
          </div>
        </main>
        <ToastContainer />
      </ListOfBasestationsProvider>
    </div>
  );
};

export default ListOfBasestations;
